// IE 2026 09 17 / ODOO-… (замечание Игоря): «блок с легендой — как для графика, так и для карты, графа —
// не должен дёргаться по размерам при наведении на разные узлы и элементы; лучше оставлять пустое место».
// Разные элементы дают разное число строк (связь 4, узел 6, страна 6 + подзаголовок) — окно прыгало.
// Держим максимум ширины / высоты, достигнутый за текущий показ: блок не сжимается обратно, пустое место
// остаётся. Максимум сбрасывается, когда панель закрыли, сменили вкладку или пришли новые данные.
//
// Выключатель: настройка базы fe.ux.legendStableSize = false (тогда блок ведёт себя как раньше).
export function stableBoxApply(el, state, enabled = true) {
    if (!el || !state) return
    if (!enabled) { el.style.minWidth = ''; el.style.minHeight = ''; return }
    // меряем БЕЗ своих ограничений, иначе максимум только растёт от собственного min-*
    const prevW = el.style.minWidth, prevH = el.style.minHeight
    el.style.minWidth = ''; el.style.minHeight = ''
    const r = el.getBoundingClientRect()
    const w = Math.ceil(r.width), h = Math.ceil(r.height)
    state.w = Math.max(state.w || 0, w)
    state.h = Math.max(state.h || 0, h)
    const mw = state.w ? state.w + 'px' : '', mh = state.h ? state.h + 'px' : ''
    if (mw !== prevW) el.style.minWidth = mw; else el.style.minWidth = prevW
    if (mh !== prevH) el.style.minHeight = mh; else el.style.minHeight = prevH
}

export function stableBoxReset(state, el) {
    if (state) { state.w = 0; state.h = 0 }
    if (el) { el.style.minWidth = ''; el.style.minHeight = '' }
}
